export const RADIUS = 6371; // km

// export enum CAMERA {
//   DISTANCE = RADIUS * 5,
//   NEAR = 1e-3,
//   FAR = RADIUS * 1000,
//   ZOOM_DEFAULT = 0.02,
//   ZOOM_MAX = 2,
//   ZOOM_MIN = 0.01,
//   ZOOM_FOCUS = 1.5,

//   DISTANCE_MIN = RADIUS + 2000,
//   DISTANCE_MAX = 40000
// }

export const CAMERA = {
  PERSPECTIVE: {
    DISTANCE: RADIUS * 5,
    NEAR: 1e-3,
    FAR: RADIUS * 1000,
    ZOOM_DEFAULT: 0.02,
    ZOOM_MAX: 2,
    ZOOM_MIN: 0.01,
    ZOOM_FOCUS: 1.5,

    DISTANCE_MIN: RADIUS + 2000,
    DISTANCE_MAX: 40000
  },
  ORTHOGRAPIC: {
    DISTANCE: RADIUS * 5,
    NEAR: 1e-3,
    FAR: RADIUS * 1000,
    ZOOM_DEFAULT: 0.2,
    ZOOM_MAX: 2,
    ZOOM_MIN: 0.01,
    ZOOM_FOCUS: 1.5,

    DISTANCE_MIN: RADIUS + 2000,
    DISTANCE_MAX: 40000
  }
};

export enum ObjectColor {
  ACTIVE = 0xffffff,
  DEFAULT = 0x00ff00,
  HOVER = 0xff69b4,

  PAYLOAD = 0x0000ff,
  STARLINK = 0x23fe00,
  ONEWEB = 0xf84f5b,
  OTHERS = 0xffdf00,

  ROCKET_BODY = 0xffa500,
  DEBRIS = 0xff0000,
  UNKNOWN = 0xb1b1b1,

  ENEMY = 0xff0000
  // rgba(0, 0, 255, 0.5)
}

export const KR_TIME_DIFF = 9 * 60 * 60 * 1000;
export const HOUR = 1000 * 60 * 60;
export const MINUTE = 1000 * 60;
export const SECOND = 1000;

export const RENDER_ORDER = {
  BEFORE: -15,
  TIME: -14,
  OBJECT: -13,
  LINE: -12,
  VISIBLE: -11,
  LABEL: -10,
  CURVE: -9,
  CAMERA: -8,
  CONTROL: -7,
  LABEL_RENDERER: -1
};
